import Loadable from '../../components/Loadable';
import { lazy } from 'react';
import { authRoles } from '../../auth/authRoles';

const Dashboard = Loadable(lazy(() => import('./Dashboard')));
const RealTimeDashboard = Loadable(lazy(() => import('./RealTimeDashboard')));

const dashboardRoutes = [
  { path: '/dashboard/default', element: <Dashboard />, auth: authRoles.guest },
  { path: '/dashboard/real-time', element: <RealTimeDashboard />, auth: authRoles.guest },
];

export default dashboardRoutes;
